import React, { useState, useEffect } from "react";
import { Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTrigger, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HairRestorationExcellence() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  return <section data-section-id="29969" id="advanced-skin-science" className="bg-background text-foreground relative min-h-screen w-full overflow-hidden flex items-center" ref={ref}>
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className={`absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/collagen_helix_3d.png')] bg-cover bg-center bg-no-repeat transition-transform duration-[20s] ease-linear ${isMounted ? "scale-110" : "scale-100"}`} />
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-background/95 via-background/60 to-transparent" />
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 sm:px-8 max-w-7xl h-full flex flex-col justify-center py-24">
        <div className={`max-w-4xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {}
          <span className="inline-block text-accent-foreground font-sans font-medium tracking-widest uppercase mb-6 text-sm md:text-base">
            The Brooke Sanctuary
          </span>

          {}
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-serif font-light italic text-foreground leading-tight tracking-tight mb-8 drop-shadow-sm">
            ADVANCED <br />
            SKIN SCIENCE
          </h1>

          {}
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mb-10 font-sans font-light leading-relaxed">
            Experience the intersection of medical precision and aesthetic artistry. 
            Discover transformative skin treatments tailored to your unique radiance.
          </p>

          {}
          <div className="flex flex-wrap gap-4">
            <Button asChild size="lg" className="bg-secondary text-secondary-foreground hover:bg-secondary/80 backdrop-blur-sm border border-border/50 rounded-lg px-10 py-7 text-lg h-auto font-sans font-medium tracking-wider shadow-md transition-all hover:scale-105">
              <Link to="tel:07766733976">Book Consultation</Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className={`absolute bottom-12 right-8 md:bottom-20 md:right-20 z-20 transition-all duration-1000 delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <Dialog>
          <DialogTrigger asChild>
            
          </DialogTrigger>
          <DialogContent className="sm:max-w-5xl bg-background border-border p-0 overflow-hidden aspect-video">
            <DialogTitle className="sr-only">Brand Experience Film</DialogTitle>
            <DialogDescription className="sr-only">
              A cinematic journey through the Natalia's Beauty experience in Brooke.
            </DialogDescription>
            <div className="w-full h-full flex items-center justify-center bg-secondary/20">
              <div className="text-center p-8">
                <Play className="w-16 h-16 text-muted-foreground/40 mx-auto mb-4" />
                <p className="text-foreground mb-2 font-serif italic text-xl">
                  The Sanctuary Experience
                </p>
                <p className="text-sm text-muted-foreground font-sans tracking-widest uppercase">
                  Cinematic Film Coming Soon
                </p>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </section>;
}